import React, { useEffect, useState } from "react";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../../table/Table"; // new
import {getAuthorization} from "../../../axios/AxiosAut";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAPIDetailsItemsTable } from "../../../redux/slices/statistics/statisticSlice";
import { setStatus } from "../../../redux/slices/item/itemSlice";
function ItemsTableData() {
  const Navigate = useNavigate();
  const [Products, setProducts] = useState();
  const APIDetailsItemsTable = useSelector(
    (state) => state.statistics.APIDetailsItemsTable
  );
  const dispatch = useDispatch();

  const getItemsList=()=>{
    getAuthorization()
    .get("product/all_products/")
    .then((res) => {
      setProducts(res.data);
      dispatch(setAPIDetailsItemsTable(res.data));

    })
    .catch((err) => {
      console.log("Error in getting products", err);
    });
  }

  useEffect(() => {
    // Get all products
    dispatch(setStatus("General"))
      getItemsList();
      console.log("inside useefeect")
  }, []);
  const data = APIDetailsItemsTable;

  const columns = React.useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "name",
      },
      {
        Header: "Product ID",
        accessor: "product_id",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: StatusPill,
      },
      {
        Header: "Type",
        accessor: "product_type",
      },
      {
        Header: "Action",
        id: "edit",
        accessor: "name",
        Cell: (value) => (
          <button
            onClick={() =>
              Navigate("/dashboard/management/items/item-details", {
                state: value.row.original.id,
              })
            }
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div className="min-h-screen">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-1">
          <Table
            columns={columns}
            data={data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default ItemsTableData;
